import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { ROLE_TYPES } from '@/constants/constants.js';
import { getSystemManagementRouteFromPathname } from '../routes/systemManagementNavigation.js';
import SystemManagementSidebar from './SystemManagementSidebar.js';
import './SystemManagementPage.scss';

const SystemManagementPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const roleId = Number(sessionStorage.getItem('role_id'));
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => (
    typeof window !== 'undefined' && window.matchMedia('(max-width: 900px)').matches
  ));
  const currentRoute = getSystemManagementRouteFromPathname(
    location.pathname,
  );

  if (roleId !== ROLE_TYPES.管理员) {
    return (
      <div className="system-management-page">
        <main className="system-management-forbidden">无权访问</main>
      </div>
    );
  }

  return (
    <div className={`system-management-page ${sidebarCollapsed ? 'is-sidebar-collapsed' : ''}`}>
      <SystemManagementSidebar
        collapsed={sidebarCollapsed}
        currentGroup={currentRoute.group}
        currentSection={currentRoute.section}
        onNavigate={navigate}
        onToggle={() => setSidebarCollapsed((current) => !current)}
      />
      <main className="system-management-content">
        <Outlet />
      </main>
    </div>
  );
};

export default SystemManagementPage;
